// gatsby-browser.ts
import "./src/styles/global.css";
import type { GatsbyBrowser } from "gatsby";
require("prismjs/themes/prism-tomorrow.css");

// Function to initialize theme
export const onClientEntry = () => {
  if (typeof window !== "undefined") {
    // On page load or when changing themes, check for saved theme preference
    const savedTheme = localStorage.getItem("theme");
    const prefersDark = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ).matches;

    if (savedTheme === "dark" || (!savedTheme && prefersDark)) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }
};

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  const consent = localStorage.getItem("cookieConsentAccepted");
  if (
    consent &&
    typeof window !== "undefined" &&
    window.posthog &&
    typeof window.posthog.capture === "function"
  ) {
    window.posthog.capture("$pageview", { path: location.pathname });
  }
};
